'use client'

import { BankDetails } from '@/screens/BankDetails'

import { InfoPageLayout } from '@/shared/lib/layouts/InfoPageLayout'

const BankDetailsPageContent = () => {
	return (
		<>
			<InfoPageLayout>
				<BankDetails />
			</InfoPageLayout>
		</>
	)
}

export function BankDetailsClient() {
	return <BankDetailsPageContent />
}
